/* Editable text fields, grouped by section.
 * type: "input" (single line) or "textarea" (multi-line)
 * path: dot-path into the i18n dict (same for FI and EN)
 * label: shown in the admin UI (in French, the user's language)
 */

export const TEXT_SECTIONS = [
  {
    id: "hero",
    title: "Hero (haut de page)",
    icon: "🎯",
    fields: [
      { path: "hero.eyebrow", label: "Bandeau (étoile)", type: "input" },
      { path: "hero.title1", label: "Titre — ligne 1", type: "input" },
      { path: "hero.title2", label: "Titre — ligne 2 (orange)", type: "input" },
      { path: "hero.sub", label: "Sous-titre", type: "textarea" },
      { path: "hero.from", label: "Mot « à partir de »", type: "input" },
      { path: "hero.ctaCall", label: "Bouton — Appeler", type: "input" },
      { path: "hero.ctaWA", label: "Bouton — WhatsApp", type: "input" },
      { path: "hero.tag", label: "Tagline (sous CTAs)", type: "input" },
    ],
  },
  {
    id: "booking",
    title: "Widget de réservation",
    icon: "📅",
    fields: [
      { path: "booking.heading", label: "Titre", type: "input" },
      { path: "booking.sub", label: "Sous-titre", type: "input" },
      { path: "booking.fromPh", label: "Placeholder adresse départ", type: "input" },
      { path: "booking.toPh", label: "Placeholder adresse arrivée", type: "input" },
      { path: "booking.service", label: "Étiquette « Type de service »", type: "input" },
      { path: "booking.asap", label: "Option « Dès que possible »", type: "input" },
      { path: "booking.seePrice", label: "Bouton « Voir le prix »", type: "input" },
      { path: "booking.result", label: "Étiquette résultat", type: "input" },
      { path: "booking.resultSub", label: "Note sous le prix", type: "input" },
      { path: "booking.bookCall", label: "Bouton « Confirmer par téléphone »", type: "input" },
      { path: "booking.bookWA", label: "Bouton « Confirmer par WhatsApp »", type: "input" },
      { path: "booking.newQuote", label: "Lien « Nouveau devis »", type: "input" },
      { path: "booking.missing", label: "Erreur — adresses manquantes", type: "input" },
    ],
  },
  {
    id: "services",
    title: "Services (3 cartes)",
    icon: "🚐",
    fields: [
      { path: "services.heading", label: "Titre de section", type: "input" },
      { path: "services.sub", label: "Sous-titre", type: "input" },
      // noLabour
      { path: "services.noLabour.t", label: "Carte 1 — Titre", type: "input" },
      { path: "services.noLabour.d", label: "Carte 1 — Description", type: "textarea" },
      { path: "services.noLabour.bullet1", label: "Carte 1 — Puce 1", type: "input" },
      { path: "services.noLabour.bullet2", label: "Carte 1 — Puce 2", type: "input" },
      { path: "services.noLabour.bullet3", label: "Carte 1 — Puce 3", type: "input" },
      // driverHelp
      { path: "services.driverHelp.t", label: "Carte 2 — Titre", type: "input" },
      { path: "services.driverHelp.d", label: "Carte 2 — Description", type: "textarea" },
      { path: "services.driverHelp.bullet1", label: "Carte 2 — Puce 1", type: "input" },
      { path: "services.driverHelp.bullet2", label: "Carte 2 — Puce 2", type: "input" },
      { path: "services.driverHelp.bullet3", label: "Carte 2 — Puce 3", type: "input" },
      // twoMen
      { path: "services.twoMen.t", label: "Carte 3 — Titre", type: "input" },
      { path: "services.twoMen.d", label: "Carte 3 — Description", type: "textarea" },
      { path: "services.twoMen.bullet1", label: "Carte 3 — Puce 1", type: "input" },
      { path: "services.twoMen.bullet2", label: "Carte 3 — Puce 2", type: "input" },
      { path: "services.twoMen.bullet3", label: "Carte 3 — Puce 3", type: "input" },
    ],
  },
  {
    id: "why",
    title: "Pourquoi Anypaku",
    icon: "⭐",
    fields: [
      { path: "why.heading", label: "Titre de section", type: "input" },
      { path: "why.sub", label: "Sous-titre", type: "input" },
      { path: "why.items.0.t", label: "Atout 1 — Titre", type: "input" },
      { path: "why.items.0.d", label: "Atout 1 — Description", type: "textarea" },
      { path: "why.items.1.t", label: "Atout 2 — Titre", type: "input" },
      { path: "why.items.1.d", label: "Atout 2 — Description", type: "textarea" },
      { path: "why.items.2.t", label: "Atout 3 — Titre", type: "input" },
      { path: "why.items.2.d", label: "Atout 3 — Description", type: "textarea" },
      { path: "why.items.3.t", label: "Atout 4 — Titre", type: "input" },
      { path: "why.items.3.d", label: "Atout 4 — Description", type: "textarea" },
    ],
  },
  {
    id: "map",
    title: "Carte / Adresse",
    icon: "📍",
    fields: [
      { path: "map.heading", label: "Titre de section", type: "input" },
      { path: "map.sub", label: "Sous-titre", type: "textarea" },
      { path: "map.name", label: "Nom de l'entreprise (à côté du logo A)", type: "input" },
      { path: "map.tagline", label: "Tagline sous le nom", type: "input" },
      { path: "map.address", label: "Adresse du dépôt", type: "input" },
      { path: "map.open", label: "Horaires", type: "input" },
      { path: "map.itinerary", label: "Bouton itinéraire", type: "input" },
    ],
  },
  {
    id: "faq",
    title: "FAQ",
    icon: "❓",
    fields: [
      { path: "faq.heading", label: "Titre de section", type: "input" },
      { path: "faq.items.0.q", label: "Q1 — Question", type: "input" },
      { path: "faq.items.0.a", label: "Q1 — Réponse", type: "textarea" },
      { path: "faq.items.1.q", label: "Q2 — Question", type: "input" },
      { path: "faq.items.1.a", label: "Q2 — Réponse", type: "textarea" },
      { path: "faq.items.2.q", label: "Q3 — Question", type: "input" },
      { path: "faq.items.2.a", label: "Q3 — Réponse", type: "textarea" },
      { path: "faq.items.3.q", label: "Q4 — Question", type: "input" },
      { path: "faq.items.3.a", label: "Q4 — Réponse", type: "textarea" },
    ],
  },
  {
    id: "footer",
    title: "Pied de page",
    icon: "🦶",
    fields: [
      { path: "footer.tag", label: "Slogan", type: "input" },
      { path: "footer.hours", label: "Horaires", type: "input" },
      { path: "footer.legal", label: "Mentions légales", type: "input" },
      { path: "footer.madeWith", label: "Petit texte « Made with sisu in Helsinki »", type: "input" },
    ],
  },
];
